function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createTwoFactor, deleteCurrentUser, deleteTwoFactor, getAuditLogs, getTwoFactorBackupCodes, getTwoFactorEnabled, logoutUser, regenerateTwoFactorBackupCodes, verifyTwoFactorCode } from '@/actions/UserActions';
import useQueryState from '@/hooks/useQueryState';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { Button, Code, HStack, Heading, Icon, IconButton, Stack, TabPanel, Tag, Td, Text, Th, Tooltip, Tr, useDisclosure } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { UAParser } from 'ua-parser-js';
import SettingsPanel from '../SettingsPanel';
import { faKey, faMobilePhone, faRefresh, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from '../Table';
import Pagination from '../Pagination';
import InputModal from '../InputModal';
import TwoFactorSetupModal from '../twofactor/TwoFactorSetupModal';
import TwoFactorRequiredModal from '../twofactor/TwoFactorRequiredModal';
import useIntlMemo from '@/hooks/useIntlMemo';
function AuditLogRow(param) {
    var log = param.log;
    var _log_ipAddressLocation, _log_ipAddressLocation1;
    var ua = React.useMemo(function() {
        return new UAParser(log.details).getResult();
    }, [
        log.details
    ]);
    return /*#__PURE__*/ _jsxs(Tr, {
        fontSize: "sm",
        children: [
            /*#__PURE__*/ _jsx(Td, {
                children: /*#__PURE__*/ _jsx(Tag, {
                    size: "sm",
                    children: log.description
                })
            }),
            /*#__PURE__*/ _jsx(Td, {
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 0,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            children: dayjs(log.createdAt).fromNow()
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            color: "textSecondary",
                            children: dayjs(log.createdAt).format('MMMM D, h:mm A')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Td, {
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 0,
                    children: [
                        ((_log_ipAddressLocation = log.ipAddressLocation) === null || _log_ipAddressLocation === void 0 ? void 0 : _log_ipAddressLocation.city) != null && ((_log_ipAddressLocation1 = log.ipAddressLocation) === null || _log_ipAddressLocation1 === void 0 ? void 0 : _log_ipAddressLocation1.country) != null ? /*#__PURE__*/ _jsxs(Text, {
                            children: [
                                log.ipAddressLocation.city,
                                ", ",
                                log.ipAddressLocation.country
                            ]
                        }) : null,
                        log.ipAddress === 'system' ? /*#__PURE__*/ _jsx(Tag, {
                            width: "fit-content",
                            size: "sm",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "+CwN9C",
                                defaultMessage: "System"
                            })
                        }) : /*#__PURE__*/ _jsx(Text, {
                            color: "textSecondary",
                            children: log.ipAddress
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Td, {
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 0,
                    children: [
                        ua.os.name != null && ua.os.version != null ? /*#__PURE__*/ _jsxs(Text, {
                            children: [
                                ua.os.name,
                                ", ",
                                ua.os.version
                            ]
                        }) : null,
                        ua.browser.name != null && ua.browser.version != null ? /*#__PURE__*/ _jsxs(Text, {
                            color: "textSecondary",
                            children: [
                                ua.browser.name,
                                ", ",
                                ua.browser.version
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
}
function SecurityPanel() {
    var user = useAuthenticationStore(function(state) {
        return state.user;
    });
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(null), 2), auditLogs = _React_useState[0], setAuditLogs = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(0), 2), page = _React_useState1[0], setPage = _React_useState1[1];
    var _useQueryState = _sliced_to_array(useQueryState('show_2fa', {
        defaultValue: false
    }), 1), showTwoFactorSettings = _useQueryState[0];
    var disableAccountModal = useDisclosure();
    var setupTwoFactorModal = useDisclosure();
    var verifyTwoFactorModal = useDisclosure();
    var disableTwoFactorModal = useDisclosure();
    var _React_useState2 = _sliced_to_array(React.useState(false), 2), twoFactorEnabled = _React_useState2[0], setTwoFactorEnabled = _React_useState2[1];
    var _React_useState3 = _sliced_to_array(React.useState(null), 2), twoFactorTokenUrl = _React_useState3[0], setTwoFactorTokenUrl = _React_useState3[1];
    var _React_useState4 = _sliced_to_array(React.useState(null), 2), twoFactorSecret = _React_useState4[0], setTwoFactorSecret = _React_useState4[1];
    var _React_useState5 = _sliced_to_array(React.useState(false), 2), twoFactorLoading = _React_useState5[0], setTwoFactorLoading = _React_useState5[1];
    var _React_useState6 = _sliced_to_array(React.useState(null), 2), twoFactorBackupCodes = _React_useState6[0], setTwoFactorBackupCodes = _React_useState6[1];
    var _React_useState7 = _sliced_to_array(React.useState(false), 2), twoFactorLoadingBackupCodes = _React_useState7[0], setTwoFactorLoadingBackupCodes = _React_useState7[1];
    React.useEffect(function() {
        getAuditLogs().then(function(logs) {
            return setAuditLogs(logs);
        }).finally(function() {});
        getTwoFactorEnabled().then(function(enabled) {
            return setTwoFactorEnabled(enabled);
        }).finally(function() {});
    }, []);
    React.useEffect(function() {
        if (twoFactorLoadingBackupCodes || twoFactorBackupCodes != null || !twoFactorEnabled) {
            return;
        }
        setTwoFactorLoadingBackupCodes(true);
        getTwoFactorBackupCodes().then(function(codes) {
            return setTwoFactorBackupCodes(codes);
        }).finally(function() {
            return setTwoFactorLoadingBackupCodes(false);
        });
    }, [
        twoFactorBackupCodes,
        twoFactorEnabled,
        twoFactorLoadingBackupCodes
    ]);
    var refreshBackupCodes = React.useCallback(function() {
        if (twoFactorLoadingBackupCodes) {
            return;
        }
        setTwoFactorLoadingBackupCodes(true);
        regenerateTwoFactorBackupCodes().then(function(codes) {
            return setTwoFactorBackupCodes(codes);
        }).finally(function() {
            return setTwoFactorLoadingBackupCodes(false);
        });
    }, [
        twoFactorLoadingBackupCodes
    ]);
    var splicedAuditLogs = React.useMemo(function() {
        if (auditLogs == null) {
            return null;
        }
        return auditLogs.slice(page * 5, page * 5 + 5);
    }, [
        auditLogs,
        page
    ]);
    var setupTwoFactor = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (twoFactorLoading) {
                return [
                    2
                ];
            }
            setTwoFactorLoading(true);
            createTwoFactor().then(function(param) {
                var url = param.url, secret = param.secret;
                setTwoFactorTokenUrl(url);
                setTwoFactorSecret(secret);
                setupTwoFactorModal.onOpen();
            }).finally(function() {
                return setTwoFactorLoading(false);
            });
            return [
                2
            ];
        });
    }), [
        setupTwoFactorModal,
        twoFactorLoading
    ]);
    var downloadBackupCodes = React.useCallback(function() {
        if (twoFactorBackupCodes == null) {
            return;
        }
        var blob = new Blob([
            twoFactorBackupCodes.join('\n')
        ], {
            type: 'text/plain'
        });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = intl.formatMessage({
            id: "8b7hBf",
            defaultMessage: [
                {
                    type: 0,
                    value: "nightbot-2fa-backup-codes.txt"
                }
            ]
        });
        a.click();
        URL.revokeObjectURL(url);
    }, [
        twoFactorBackupCodes,
        intl
    ]);
    var disableTwoFactor = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (twoFactorLoading) {
                        return [
                            2
                        ];
                    }
                    setTwoFactorLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        deleteTwoFactor()
                    ];
                case 2:
                    _state.sent();
                    setTwoFactorEnabled(false);
                    return [
                        3,
                        4
                    ];
                case 3:
                    setTwoFactorLoading(false);
                    setTwoFactorBackupCodes(null);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        twoFactorLoading
    ]);
    var confirmationText = useIntlMemo(function(intl) {
        var _user_displayName;
        return intl.formatMessage({
            id: "S0RolL",
            defaultMessage: [
                {
                    type: 0,
                    value: "I, "
                },
                {
                    type: 1,
                    value: "displayName"
                },
                {
                    type: 0,
                    value: ", wish to disable my account."
                }
            ]
        }, {
            displayName: (_user_displayName = user === null || user === void 0 ? void 0 : user.displayName) !== null && _user_displayName !== void 0 ? _user_displayName : ''
        });
    });
    var disableAccount = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(submitText) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (submitText.trim().toLowerCase() !== confirmationText.toLowerCase() && submitText.trim().toLowerCase() !== 'execute order 66') {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            deleteCurrentUser()
                        ];
                    case 1:
                        _state.sent();
                        logoutUser();
                        return [
                            2
                        ];
                }
            });
        });
        return function(submitText) {
            return _ref.apply(this, arguments);
        };
    }(), [
        confirmationText
    ]);
    var verifyTwoFactor = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(code) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            verifyTwoFactorCode(code)
                        ];
                    case 1:
                        _state.sent();
                        setTwoFactorEnabled(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function(code) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    if (user == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(TabPanel, {
        as: Stack,
        spacing: 6,
        py: 6,
        px: 0,
        children: [
            showTwoFactorSettings || twoFactorEnabled || user.admin ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "o0D8La",
                            defaultMessage: "Two Factor"
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        icon: faMobilePhone,
                        heading: intl.formatMessage({
                            id: "28LyaX",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Two Factor Authentication"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "BD2gsQ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Add an extra layer of security to your account"
                                }
                            ]
                        }),
                        afterElement: !twoFactorEnabled ? /*#__PURE__*/ _jsx(Button, {
                            size: "sm",
                            onClick: setupTwoFactor,
                            isLoading: twoFactorLoading,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "dvr19k",
                                defaultMessage: "Setup"
                            })
                        }) : /*#__PURE__*/ _jsx(Button, {
                            size: "sm",
                            colorScheme: "red",
                            onClick: disableTwoFactorModal.onOpen,
                            isLoading: twoFactorLoading,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "9mUEeY",
                                defaultMessage: "Turn Off"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        icon: faKey,
                        heading: intl.formatMessage({
                            id: "RrL8zs",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Backup Codes"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "KBaFVK",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "List of backup codes for two factor authentication"
                                }
                            ]
                        }),
                        afterElement: /*#__PURE__*/ _jsxs(HStack, {
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    size: "sm",
                                    isDisabled: twoFactorBackupCodes == null || twoFactorLoadingBackupCodes,
                                    onClick: function() {
                                        return downloadBackupCodes();
                                    },
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "5q3qC0",
                                        defaultMessage: "Download"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    label: intl.formatMessage({
                                        id: "ZImYO5",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Regenerate backup codes"
                                            }
                                        ]
                                    }),
                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                        size: "sm",
                                        "aria-label": "Regenerate",
                                        isLoading: twoFactorLoadingBackupCodes,
                                        isDisabled: twoFactorBackupCodes == null,
                                        onClick: refreshBackupCodes,
                                        icon: /*#__PURE__*/ _jsx(Icon, {
                                            as: FontAwesomeIcon,
                                            icon: faRefresh
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "t/TuwD",
                    defaultMessage: "Audit Logs"
                })
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: splicedAuditLogs,
                extraData: [
                    page,
                    auditLogs === null || auditLogs === void 0 ? void 0 : auditLogs.length
                ],
                renderHeader: function() {
                    return /*#__PURE__*/ _jsxs(Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(Th, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "QlsDcr",
                                    defaultMessage: "Action"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Th, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "McnLsx",
                                    defaultMessage: "When"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Th, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "rvirM2",
                                    defaultMessage: "Location"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Th, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "c3VJQo",
                                    defaultMessage: "Device"
                                })
                            })
                        ]
                    });
                },
                renderRow: function(row) {
                    return /*#__PURE__*/ _jsx(AuditLogRow, {
                        log: row
                    });
                },
                renderFooter: function() {
                    var _auditLogs_length;
                    return /*#__PURE__*/ _jsx(Pagination, {
                        limit: 5,
                        page: page,
                        total: (_auditLogs_length = auditLogs === null || auditLogs === void 0 ? void 0 : auditLogs.length) !== null && _auditLogs_length !== void 0 ? _auditLogs_length : 0,
                        nextPage: function() {
                            return setPage(page + 1);
                        },
                        previousPage: function() {
                            return setPage(page - 1);
                        }
                    });
                }
            }),
            /*#__PURE__*/ _jsx(Heading, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "X5rIjZ",
                    defaultMessage: "Danger Zone"
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faWarning,
                heading: intl.formatMessage({
                    id: "YBI+WM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disable Account"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "GRPofb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disabling your account will log you out and revoke access"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Button, {
                    size: "sm",
                    colorScheme: "red",
                    onClick: disableAccountModal.onOpen,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "YBI+WM",
                        defaultMessage: "Disable Account"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: disableAccountModal.isOpen,
                onClose: disableAccountModal.onClose,
                title: intl.formatMessage({
                    id: "YBI+WM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disable Account"
                        }
                    ]
                }),
                description: /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            color: "textSecondary",
                            children: intl.formatMessage({
                                id: "vIaTBG",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Disabling your account will log you out and revoke access. Please confirm by typing the following:"
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Code, {
                            colorScheme: "red",
                            children: confirmationText
                        })
                    ]
                }),
                input: {
                    placeholder: confirmationText
                },
                submitText: intl.formatMessage({
                    id: "Rw7iI7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disable"
                        }
                    ]
                }),
                onSubmit: disableAccount
            }),
            /*#__PURE__*/ _jsx(TwoFactorSetupModal, {
                isOpen: setupTwoFactorModal.isOpen,
                onClose: setupTwoFactorModal.onClose,
                twoFactorSecret: twoFactorSecret,
                twoFactorUrl: twoFactorTokenUrl,
                onComplete: function() {
                    return setTimeout(function() {
                        return verifyTwoFactorModal.onOpen();
                    }, 500);
                }
            }),
            /*#__PURE__*/ _jsx(TwoFactorRequiredModal, {
                isOpen: verifyTwoFactorModal.isOpen,
                onClose: verifyTwoFactorModal.onClose,
                heading: intl.formatMessage({
                    id: "u5kFTY",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enable Two Factor Authentication"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "GXx04S",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Verify you have setup two factor authentication, by entering the code from your authenticator app below."
                        }
                    ]
                }),
                onComplete: verifyTwoFactor,
                showBackupCodeInput: false
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: disableTwoFactorModal.isOpen,
                onClose: disableTwoFactorModal.onClose,
                title: intl.formatMessage({
                    id: "HsTMBT",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disable Two Factor Authentication"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "ZXGb8Q",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disabling two factor authentication will remove the extra layer of security on your account."
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "Rw7iI7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Disable"
                        }
                    ]
                }),
                onSubmit: disableTwoFactor
            })
        ]
    });
}
export default SecurityPanel;
